<div class="menu-toggle" [class.active]="active" [class.inactive]="!active" (click)="onToggle();">
    <span class="menu-toggle__upper"></span>
    <span class="menu-toggle__lower"></span>
</div>